import script from "./WorkgroupDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkgroupDetails.vue?vue&type=script&setup=true&lang=js"

import "./WorkgroupDetails.vue?vue&type=style&index=0&id=6f734c00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f734c00"]])

export default __exports__